import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Account } from '@app/models/account';
import { AccountFilter } from '@app/models/account-filter';
import { ConfirmationService } from "primeng/api";
import {AccountService} from "@app/services/account.service";

@Component({
    selector: 'app-account-tree-popup',
    templateUrl: './account-tree-popup.component.html',
    styleUrls: ['./account-tree-popup.component.css'],
    standalone: false
})
export class AccountTreePopupComponent implements OnInit {

  @Input() selectedAccount: any;
  @Input() displaySearchDialog: boolean;
  @Input() hideClosedAccount: boolean;
  @Input() isForeignCurrencyAccount: boolean;
  @Input() loadAccount: boolean;
  @Input() allowSelectAccountType: boolean;
  @Input() currency: string;
  @Input() kindOfAccountType: number; //1: only normal account; 2 only: offbalance account; else all
  @Output() onSubmit = new EventEmitter<Account>();
  @Output() onCancel = new EventEmitter();

  
  accountFilter: AccountFilter;
  isFilterAccount : boolean = false;
  
  constructor(
    private confirmationService: ConfirmationService,
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
    this.accountFilter = new AccountFilter();
    if (!this.selectedAccount) {
      this.selectedAccount = new Account();
    }
    this.accountService.selectedAccount = this.selectedAccount;
    if (this.loadAccount === undefined) {
      this.loadAccount = true;
    }
    if (this.allowSelectAccountType === undefined) {
      this.allowSelectAccountType = false;
    }
    if (this.hideClosedAccount === undefined) {
      this.hideClosedAccount = true;
    }
  }

  addAccountType(accountType) {
    this.selectedAccount = accountType;
    this.accountService.selectedAccount = accountType;
  }

  addAccount(account) {
    this.selectedAccount = account;
    this.accountService.selectedAccount = account;
  }

  removeSelectedAccount() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete selected account ' + this.selectedAccount.name + ' ?',
      accept: () => {
        if (this.accountService.selectedAccount) {
          this.accountService.selectedAccount = undefined;
        }
      }
    });
  }

  cancelSearch() {
    this.onCancel.emit();
  }

  onSelect() {
    if (this.accountService.selectedAccount && (this.accountService.selectedAccount.code || this.accountService.selectedAccount.number)) {
      this.onSubmit.emit(this.accountService.selectedAccount);
    } else {
      this.onSubmit.emit(undefined);
    }
  }
  
  triggerFilterAccount(accountFilter){
    this.isFilterAccount = true;
    this.accountFilter = {...accountFilter};
  }

  resetFilterAccount(){
    this.isFilterAccount = false;
    this.accountFilter = new AccountFilter();
  }

  getSelectedAccount() {
    return this.selectedAccount;
  }

  deleteSelectedAccount() {
    this.selectedAccount = null;
    this.accountService.selectedAccount = null;
  }

  removeAccount() {
    this.selectedAccount = null;
  }
}
